import React from 'react'; // eslint-disable-line no-unused-vars

import withSalonCurrency from 'components/hoc/withSalonCurrency.hoc';
import currencySign from 'utils/intl/currencySign.util';

// NOTE: would be nice to have <span> as top level element, but it messes up with global CSS
const CurrencySign = (props) => currencySign(props);

const CurrencySignHoC = withSalonCurrency(CurrencySign);

// this extra export is needed for tests that provide their own mock for connect()
export { CurrencySign as CurrencySign4Test, CurrencySignHoC as CurrencySignHoC4Test };

// noinspection JSUnusedGlobalSymbols
export default CurrencySignHoC;
